import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import "./i18n/config";

// The prerendered static HTML ships a crawlable #seo-fallback block containing an
// <h1> so non-JS crawlers see real content. Once React hydrates, the route renders
// its own <h1> — leaving both in the DOM produced the "multiple <h1>" audit warning.
// Removing the fallback at hydration guarantees exactly one <h1> in both the raw
// HTML and the rendered DOM.
document.getElementById("seo-fallback")?.remove();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
